import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class ScreenService {

    static readonly ASPECT_RATIO_4x3 = 1.33333333;
    static readonly ASPECT_RATIO_16x9 = 1.7777778;
    static readonly FULLHD_WIDTH = 1920;
    static readonly FULLHD_HEIGHT = 1080;

    private _toolbarOffset = 0;
    private _headerOffset = 0;

    private _aspectRatio = 0.0;
    private _realAspectRatio = 0.0;

    private screenResizedEmmiter: EventEmitter<{ width: number, height: number }> = new EventEmitter();

    constructor() {
        this.initRatio();
        window.addEventListener('resize', () => {
            this.initRatio();
            this.screenResizedEmmiter.emit({width: this.getContainerWidth(), height: this.getContainerHeight()});
        });
        window.addEventListener('DOMContnetLoaded', () => {
            this._toolbarOffset = window.document.querySelector('.toolbar').clientHeight;
        });
    }


    set toolbarOffset(value: number) {
        this._toolbarOffset = value;
        this.initRatio();
    }

    set headerOffset(value: number) {
        this._headerOffset = value;
        this.initRatio();
    }

    get toolbarOffset() {
        return this._toolbarOffset;
    }

    get headerOffset() {
        return this._headerOffset;
    }

    isPortraitOrientation() {
        return (this.viewport().width / this.viewport().height) < 1;
    }

    isAlbumOrientation() {
        return !this.isPortraitOrientation();
    }

    get aspectRatio() {
        return this._aspectRatio;
    }

    get realAspectRatio() {
        return this._realAspectRatio;
    }

    initRatio() {
        const height = this.viewport().height - this._headerOffset - this._toolbarOffset;
        this._realAspectRatio = this.viewport().width / height;
        this._aspectRatio = ScreenService.ASPECT_RATIO_16x9;
    }

    public viewport() {
        let e: any = window,
            a: any = 'inner';
        if (!( 'innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        a = 'client';
        e = document.documentElement || document.body;
        return {width: e[a + 'Width'], height: e[a + 'Height']};
    }

    getContainerWidth(): number {
        // if (this._realAspectRatio > 1) {
        //     const height = this.getContainerHeight();
        //     return Math.floor(height * this._realAspectRatio);
        // } else {
        //     return this.viewport().width;
        // }
        return this.viewport().width;
    }

    getContainerHeight(): number {
        const height = this.viewport().height - this._headerOffset - this._toolbarOffset;
        return height;
        // if (this._realAspectRatio > 1) {
        //     const height = this.viewport().height - this._headerOffset - this._toolbarOffset;
        //     return height;
        // } else {
        //     const width = this.getContainerWidth();
        //     return Math.floor(width / this._realAspectRatio);
        // }
    }

    topOfsset() {
        return this._headerOffset;
    }

    addScreenResizedListener(listener: (newSize: { width: number, height: number }) => void) {
        return this.screenResizedEmmiter.subscribe(listener);
    }
}


// WEBPACK FOOTER //
// ./src/app/common/services/screen.service.ts